module.exports = __webpack_public_path__ + "img/partner_16.bfafd645.png";